import React from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import useCreateThumbPreview from "components/Pages/Home/Helpers/useCreateThumbPreview.js";
import UploadGalleryIcon from "components/Pages/Home/UploaderComponent/UploadGalleryIcon.js";
import useLightboxOpenPreview from "components/Pages/Home/Helpers/useLightboxOpenPreview.js";
import useFileProgress from "components/Pages/Home/Helpers/useFileProgress.js";
import { CircularProgressbar } from "react-circular-progressbar";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const PreviewItem = ({ file, preview, progress }) => {
  const { uploaderRemoveFile, getIsUppy, getUploading } = useUploader();

  const size = bytesToDisplayHelper(file.size);

  const fileObj = getIsUppy() ? file : file.file;

  const thumbPreview = useCreateThumbPreview(fileObj, preview);

  const { handleOpenLightbox } = useLightboxOpenPreview(fileObj);

  const { isComplete, isError, persentegeProgress } = useFileProgress(
    fileObj,
    progress
  );

  const handleLightbox = () => {
    if (!getUploading()) {
      handleOpenLightbox();
    }
  };

  const progressCircle =
    persentegeProgress > 97 && persentegeProgress < 100
      ? 97
      : persentegeProgress;

  return (
    <div className="preview-item">
      <div className="item-icon" onClick={handleLightbox}>
        {getUploading() ? (
          <div className="progress-item-container">
            {isComplete ? (
              <Icon name="check" green />
            ) : isError ? (
              <Icon name="warning" red />
            ) : (
              <CircularProgressbar
                value={progressCircle || "1"}
                text={(persentegeProgress || "0") + "%"}
                strokeWidth={3}
              />
            )}
          </div>
        ) : null}
        <UploadGalleryIcon
          thumbPreview={thumbPreview}
          file={file}
          noFooter={true}
        />
      </div>
      <div className="item-name" title={file.name}>
        {file.name}
        <div className="item-size">{size.size + size.type}</div>
      </div>
      {getUploading() ? null : (
        <div
          className="item-remove"
          onClick={() => {
            uploaderRemoveFile(file.id);
          }}
        >
          <Icon name="x" white />
        </div>
      )}
    </div>
  );
};

export default PreviewItem;
